import { useSyncExternalStore } from 'react'
import { useRouter } from 'next/router'

import { TOGGLE_FEATURES } from 'configs/toggle-feature'
import { useDesktopView } from 'utils/hooks/useDesktopView'

const DESKTOP_DETAIL_QUERY = '(min-width: 1024px)'
const PELATIHAN_MANDIRI_LANDING_PATHS = [
  '/pelatihan-mandiri',
  '/pelatihan-mandiri/daftar-topik',
  '/pelatihan-mandiri/daftar-aksi-nyata',
  '/pelatihan-mandiri/webinar',
]

const subscribe = (onStoreChange: () => void) => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return () => {}
  }

  const mediaQuery = window.matchMedia(DESKTOP_DETAIL_QUERY)
  mediaQuery.addEventListener?.('change', onStoreChange)

  return () => {
    mediaQuery.removeEventListener?.('change', onStoreChange)
  }
}

const getSnapshot = () =>
  typeof window !== 'undefined' &&
  Boolean(window.matchMedia?.(DESKTOP_DETAIL_QUERY).matches)

const getServerSnapshot = () => false

export const usePelatihanMandiriDesktopDetailView = () => {
  const { pathname } = useRouter()
  const isEnabled = useDesktopView(
    TOGGLE_FEATURES.PELATIHAN_MANDIRI_DESKTOP_DETAIL
  )
  const isDesktopViewport = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  )

  const isDetailRoute = !PELATIHAN_MANDIRI_LANDING_PATHS.includes(pathname)

  return isDetailRoute && isEnabled && isDesktopViewport
}
